const LANG_SUFFIX = { english: 'en', hebrew: 'he' };

export function mascotLang(language) {
  return LANG_SUFFIX[language] || 'en';
}

/** Public URL for a step clip — prefers mp4 (Veo export), then webm. */
export function getMascotVideoCandidates(stepId, language) {
  const lang = mascotLang(language);
  return [
    `/mascot/steps/${stepId}.${lang}.mp4`,
    `/mascot/steps/${stepId}.${lang}.webm`,
    // English fallback when Hebrew clip not produced yet
    ...(lang !== 'en' ? [`/mascot/steps/${stepId}.en.mp4`, `/mascot/steps/${stepId}.en.webm`] : []),
  ];
}

export function getMascotPosterSrc(stepId) {
  return `/mascot/poses/${stepId}.png`;
}

export const MASCOT_IDLE_POSTER = '/mascot/poses/idle.png';
